import FormArchives from '../../DAL/FormArchives'
import { getDocs, collection } from 'firebase/firestore'
import {store} from '../utilities'

export default function readIcons(archiveId) {
  return function () {
    if (!archiveId) return
    async function fetch() {
      const formArchives = new FormArchives()
      const snap = await getDocs(collection(formArchives.docRef(archiveId), 'icons'))
      const icons = snap.docs.map((d) => ({id: d.id, ...d.data()}))
      store.dispatch({type: 'icons', payload: icons})
    }
    fetch()
  }
}
